import React, { Component } from "react";


export default class applogic extends Component {
  componentDidMount() {
    const script = document.createElement("script");

    script.src = "https://apps.applozic.com/sidebox.app";
    script.async = true;
console.log("script",script);
    document.body.appendChild(script);
  }


}